let params: URLSearchParams

export function getAllLocationAttributes() {
    params = new URLSearchParams(window.location.search);
    // @ts-ignore
    return Object.fromEntries(params);
}

export function removeLocationAttribute(name:string) {
    if (!params) {
        getAllLocationAttributes();
    }

    params.delete(name)
}

export function getLocationAttribute(name:string) {
    if (!params) {
        getAllLocationAttributes();
    }

    return params.get(name);
}

interface LocationProps {
    [index: string]: any;
}

export default class Location {
    public oParametre: LocationProps

    public setLocationAttribute(name:string,value:any):void {
        if (!this.oParametre) {
            this.getAllLocationAttributes();
        }
        this.removeLocationAttribute(name);
        let hasValue = typeof value != "undefined";
        if (hasValue) {
            if (Array.isArray(value)) {
                const tmp = [];
                for (let i = 0; i < value.length; i++) {
                    if (value[i] + "" != "") {
                        tmp.push(value[i]);
                    }
                }
                value = tmp;
            } else {
                value = value + "";
                hasValue = value != "";
                const tmp = [];
                if (hasValue) {
                    tmp.push(value + "");
                }
                value = tmp;
            }
        } else {
            value = [];
        }
        if (value.length > 0) {
            this.oParametre[name] = value;
        }
    }
    public removeLocationAttribute(name:string):void {
        if (!this.oParametre) {
            this.getAllLocationAttributes();
        }
        if (this.oParametre[name]) {
            delete this.oParametre[name];
        }
    }
    public getAllLocationAttributes(): LocationProps {
        if (!this.oParametre) {
            this.oParametre = {};
            if (window.location.search.length > 1) {
                const allAttributes = window.location.search.substr(1).split("&");
                for (let i = 0; i < allAttributes.length; i++) {
                    const toks = allAttributes[i].split("=");
                    if (toks.length == 2) {
                        const name = decodeURIComponent(toks[0]);
                        const attr = decodeURIComponent(toks[1]);
                        if (name.length > 0 && attr.length > 0) {
                            if (this.oParametre[name]) {
                                const val = this.oParametre[name];
                                if (Array.isArray(val)) {
                                    this.oParametre[name].push(attr);
                                } else {
                                    this.oParametre[name] = [];
                                    this.oParametre[name].push(val);
                                    this.oParametre[name].push(attr);
                                }
                            } else {
                                this.oParametre[name] = attr;
                            }
                        }
                    }

                }
            }
        }
        return this.oParametre;
    }
    public reloadLocationWithAttributes():void {
        if (this.oParametre) {
            let result = "";
            for (const key in this.oParametre) {
                const param = this.oParametre[key];
                if (Array.isArray(param)) {
                    for (let i = 0; i < param.length; i++) {
                        result += "&" + key + "=" + this.encodeQueryParameter(param[i]);
                    }
                } else {
                    result += "&" + key + "=" + this.encodeQueryParameter(param);
                }
            }
            if (result.length > 0) {
                result = "?" + result.substr(1);
            }

            const tokens = window.location.href.split("?");
            window.history.replaceState(null, null, tokens[0] + result);
        }
    }

    // Encode every reserved character except "+" (used for location)
    private encodeQueryParameter(parameter: string): string {
        return parameter.split("+").map(part => encodeURIComponent(part)).join("+");
    }

    public getLocationAttribute(name:string):any{
        if (!this.oParametre) {
            this.getAllLocationAttributes();
        }
        return this.oParametre[name];
    }
}